import axios from "axios";

const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Custom domains serve /api too; staying same-origin keeps login cookies first-party.
export const BACKEND_URL = window.location.origin === new URL(ENV_BACKEND_URL).origin ? ENV_BACKEND_URL : window.location.origin;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
export const dmUrl = (username) => `https://ig.me/m/${username}`;
export const igUrl = (username) => `https://www.instagram.com/${username}/`;
export const embedUrl = (username) => `https://www.instagram.com/${username}/embed/`;
export const fmtCount = (n = 0) => new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 }).format(n);
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) {
    if (d.some((x) => x?.loc?.includes("zip"))) return "Enter a 5-digit ZIP code";
    if (d.some((x) => x?.loc?.includes("location") || x?.loc?.includes("city") || x?.loc?.includes("state"))) return "Fill in your city, state and ZIP code";
    return d.map((x) => x?.msg).filter(Boolean).join(" ");
  }
  if (typeof d === "string") return d;
  if (!e?.response) return "Can't reach Nailora right now. Check your connection and try again.";
  return `Nailora is having trouble right now (error ${e.response.status}). Please try again in a minute.`;
};
export const fmtLocation = (t) => [[t?.city, t?.state].filter(Boolean).join(", "), t?.zip].filter(Boolean).join(" ");
